import { TypeInitProps, TypeRequest } from '../../types';
import { WEB_URL } from '../../utils/urls';

export default class CancelAPI {
  private request: TypeRequest;
  constructor(props: TypeInitProps & { request: TypeRequest }) {
    const { request } = props;
    this.request = request;
  }

  /**
   * @param {string} cancel_ticket - Ticket returned by cancel_check API
   * @return {Promise} - result
   */
  verifyWay = (params: { cancel_ticket?: string; extra_params?: object }) => {
    const { cancel_ticket, extra_params = {} } = params;
    return this.request({
      url: WEB_URL.CANCEL_VERIFY_WAY,
      method: 'GET',
      data: {
        cancel_ticket,
        ...extra_params,
      },
    });
  };

  /**
   * @param {string} value_ticket - A ticket representing the value of the user
   * @return {Promise} - result
   */
  checkIfPass = (params: { value_ticket?: string; extra_params?: object }) => {
    const { value_ticket, extra_params } = params;
    return this.request({
      url: WEB_URL.CANCEL_CHECK,
      method: 'GET',
      data: {
        value_ticket,
        ...extra_params,
      },
    });
  };

  /**
   * @param {string} value_ticket - A ticket representing the value of the user
   * @param {string} token - A ticket obtained after verification such as mobile phone number verification code
   * @param {string} cancel_ticket - Ticket returned by cancel_check API
   * @param {string} abandon - A comma-separated string containing abandoned assets
   * @return {Promise} - result
   */
  confirm = (params: {
    value_ticket?: string;
    token?: string;
    cancel_ticket?: string;
    abandon?: string;
    extra_params?: object;
  }) => {
    const {
      value_ticket,
      token,
      cancel_ticket,
      abandon,
      extra_params = {},
    } = params;
    return this.request({
      url: WEB_URL.CANCEL_CONFIRM,
      method: 'POST',
      data: {
        value_ticket,
        token,
        cancel_ticket,
        abandon,
        ...extra_params,
      },
    });
  };

  /**
   * @param {string} id_uri1
   * @param {string} id_uri2
   * @param {string} apply_uri
   * @param {string} ticket
   * @return {Promise} - result
   */
  cancelRequest = (params: {
    id_uri1?: string;
    id_uri2?: string;
    apply_uri?: string;
    ticket: string;
    extra_params?: object;
  }) => {
    const { id_uri1, id_uri2, apply_uri, ticket, extra_params = {} } = params;
    return this.request({
      url: WEB_URL.CANCEL_REQUEST,
      method: 'POST',
      data: {
        id_uri1,
        id_uri2,
        apply_uri,
        ticket,
        ...extra_params,
      },
    });
  };

  /**
   * @param {number} type
   * @param {string} token
   * @return {Promise} - result
   */
  cancelLogin = (params: {
    type: number;
    token?: string;
    extra_params?: object;
  }) => {
    const { type, token, extra_params = {} } = params;
    return this.request({
      url: WEB_URL.CANCEL_LOGIN,
      method: 'POST',
      data: {
        type,
        token,
        ...extra_params,
      },
    });
  };
}
